import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteUpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";

export type HandlerType = Parameters<typeof DispatchCompleteUpdateCart>[0];

addToChainAfter(chain, DispatchCompleteUpdateCart, ClearCheckoutShippingPageNotes);
// This is a base bug fix for persisting order notes between orders when using the same session
function ClearCheckoutShippingPageNotes(props: HandlerType) {
    props.dispatch({
        type: "Pages/CheckoutShipping/SetNotes",
        notes: "",
    });
}
